import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';

import * as actions from '../actions';
import * as c from '../constant';

function ApproveConfirmationRenewalModal({
  approveRenewal,
  approving,
  id,
  getItem,
  refreshList,
}) {
  const setModal = useContext(ModalContext);
  const handleOnSubmit = e => {
    e.preventDefault();

    approveRenewal(id, {}, () => {
      setModal({ isOpen: false });
      refreshList(id);
      getItem(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="full-group-v2">
          <div className="mt-2 pt-2 d-flex col-12">
            <p>Are you sure you want to approve this application?</p>
          </div>
          <hr />
          <div className="d-flex justify-content-center">
            <button
              disabled={approving}
              type="button"
              onClick={closeModal}
              className="mt-3 btn btn-default"
            >
              <span className="font-weight-bold">Cancel</span>
            </button>
            <button
              disabled={approving}
              type="submit"
              className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
            >
              <span className="font-weight-bold">
                {approving ? <i className="fa fa-spin fa-spinner" /> : `Approve`}
              </span>
            </button>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

ApproveConfirmationRenewalModal.propTypes = {
  approveRenewal: PropTypes.instanceOf(Function).isRequired,
  approving: PropTypes.bool.isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  refreshList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  approving: api.loading.indexOf(c.APPROVE_RENEWAL) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ApproveConfirmationRenewalModal);
